module.exports = __webpack_public_path__ + "static/media/tachometer-slowest.cbb3ace8.svg";